import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'superflex-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
    private datosTabla: any[] = [];
    private totalRegistros = 0;

    @Input() cols: any[];

    @Output() pagination = new EventEmitter<any>();

    @Input() hasEdit = false;
    @Input() hasDetail = false;
    @Input() hasDelete = false;
    @Input() paginator: boolean;
    @Input() lazy: boolean;
    @Input() styleClass = "p-datatable-datos";
    @Output() onEdit = new EventEmitter<any>();
    @Output() onDetail = new EventEmitter<any>();
    @Output() onDelete = new EventEmitter<any>();

    selected: any;
    rows: number = environment.rowsPerPage;
    isNotRowSelected = true;
    first = 0;

    constructor() {
        //
    }

    ngOnInit(): void {
        //
    }

    @Input() set dataTable(data: any) {
        if (data) {
            this.datosTabla = data.data;
            this.totalRegistros = data.totalRecords;
            this.isNotRowSelected = true;
            this.selected = null;
            if (data.isFirst) {
                this.first = 0;
            }
        }
    }

    get dataTable(): any {
        return this.datosTabla;
    }
    get totalRecords(): any {
        return this.totalRegistros;
    }

    paginationEmitter(event): void {
        if (this.totalRecords > 0) {
            this.pagination.emit(event.first / event.rows);
        }
    }

    editEmitter(): any {
        this.onEdit.emit(this.selected);
    }
    detailEmitter(): any {
        this.onDetail.emit(this.selected);
    }
    deleteEmitter(): any {
        this.onDelete.emit(this.selected);
    }
}
